
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题

import $ from 'jquery'
import 'bootstrap'

import 'bootstrap/dist/css/bootstrap.min.css'

import 'bootstrap/dist/js/bootstrap.min.js'

import 'swiper/css/swiper.css'
import './assets/font/font.css'


import wow from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
import i18n from './lang'
//这里需要将样式用起来，
Vue.use(animated)


// 跳转后返回顶部
router.afterEach((to,from,next) => {
  setTimeout(()=>{
    if( to.query && to.query.m ) {
      let m = to.query.m;
      let scroll= document.getElementById(m).offsetTop;
     document.getElementsByClassName('eswin-main')[0].scrollTop = scroll-100;
    } else {
      document.getElementsByClassName('eswin-main')[0].scrollTo(0,0);
    }
  },100)
})

Vue.prototype.$ = $

Vue.config.productionTip = false
Vue.use(ElementUI, {
	size: 'small'
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js